module.exports = __webpack_public_path__ + "assets/ilustrasi-layanan-master-data-offline.ab4530ff.svg";